import Requisicao from './RequisicaoService';

class SistemaService {
    static async buscarById(id) {        
        return Requisicao.get('sistema/' + id);        
    }

    static async configuracao(dados) {
        return Requisicao.post('sistema', dados);
    } 

    static async atualizarSenhaCPanel(id, senha) {        
        return Requisicao.patch('sistema/password/cpanel', {
            id: id,
            senha: senha
        });
    }

    static async getSenhaCPanel(id) {               
        return Requisicao.get('sistema/password/cpanel/' + id);
    }

    static async atualizarSenhaDB(id, senha) {        
        return Requisicao.patch('sistema/password/db', {
            id: id,
            senha: senha
        });
    }
    
    static async getSenhaDB(id) {        
        return Requisicao.get('sistema/password/db/' + id);
    }    

    static async aguardandoInstalacao(id) {
        return Requisicao.patch('sistema/update-status/aguardando-instalacao', {
            id: id
        });
    }
}

export default SistemaService;